"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthographicEventDistribution = void 0;
var OrthographicEventDistribution = /** @class */ (function () {
    // #endregion Properties (1)
    // #region Constructors (1)
    function OrthographicEventDistribution(_settings, _controls, _cameraLogic) {
        this._settings = _settings;
        this._controls = _controls;
        this._cameraLogic = _cameraLogic;
        // #region Properties (1)
        this._active = {
            zoom: false,
            pan: false
        };
    }
    // #endregion Constructors (1)
    // #region Public Methods (14)
    OrthographicEventDistribution.prototype.onDown = function (event) {
        var _a = this.convertInput(event), x = _a.x, y = _a.y;
        var input = window.TouchEvent && event instanceof TouchEvent ? event.touches.length : event.button;
        var mapping = window.TouchEvent && event instanceof TouchEvent ? this._settings.getSetting('input').touch : this._settings.getSetting('input').mouse;
        if (input === mapping.pan && this._settings.getSetting('enablePan')) {
            this._cameraLogic.pan(x, y, this._active.pan, window.TouchEvent && event instanceof TouchEvent);
            this._active.pan = true;
            this._active.zoom = false;
        }
        if (input === mapping.zoom && this._settings.getSetting('enableZoom')) {
            var x1 = x, y1 = y;
            if (window.TouchEvent && event instanceof TouchEvent && this._settings.getSetting('input').touch.zoom === 2) {
                x1 = (event.touches[0].pageX - event.touches[1].pageX) / window.innerWidth * (window.innerWidth / window.innerHeight);
                y1 = (event.touches[0].pageY - event.touches[1].pageY) / window.innerHeight;
            }
            this._cameraLogic.zoom(x1, y1, this._active.zoom, window.TouchEvent && event instanceof TouchEvent);
            this._active.pan = false;
            this._active.zoom = true;
        }
    };
    OrthographicEventDistribution.prototype.onKey = function (event) {
        if (this._settings.getSetting('enableKeyPan')) {
            switch (event.keyCode) {
                case this._settings.getSetting('input').keys.up:
                    this._cameraLogic.pan(0, 0, false, false);
                    this._cameraLogic.pan(0, this._settings.getSetting('keyPanSpeed') * 0.05, true, false);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case this._settings.getSetting('input').keys.down:
                    this._cameraLogic.pan(0, 0, false, false);
                    this._cameraLogic.pan(0, -this._settings.getSetting('keyPanSpeed') * 0.05, true, false);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case this._settings.getSetting('input').keys.left:
                    this._cameraLogic.pan(0, 0, false, false);
                    this._cameraLogic.pan(this._settings.getSetting('keyPanSpeed') * 0.05, 0, true, false);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case this._settings.getSetting('input').keys.right:
                    this._cameraLogic.pan(0, 0, false, false);
                    this._cameraLogic.pan(-this._settings.getSetting('keyPanSpeed') * 0.05, 0, true, false);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
            }
        }
    };
    OrthographicEventDistribution.prototype.onKeyDown = function (event) {
        this.onKey(event);
    };
    OrthographicEventDistribution.prototype.onMouseDown = function (event) {
        this.onDown(event);
    };
    OrthographicEventDistribution.prototype.onMouseMove = function (event) {
        this.onMove(event);
    };
    OrthographicEventDistribution.prototype.onMouseUp = function (event) {
        this.onUp(event);
    };
    OrthographicEventDistribution.prototype.onMouseWheel = function (event) {
        this.onWheel(event);
    };
    OrthographicEventDistribution.prototype.onMove = function (event) {
        var _a = this.convertInput(event), x = _a.x, y = _a.y;
        if (this._settings.getSetting('enablePan') && this._active.pan)
            this._cameraLogic.pan(x, y, this._active.pan, window.TouchEvent && event instanceof TouchEvent);
        if (this._settings.getSetting('enableZoom') && this._active.zoom) {
            var x1 = x, y1 = y;
            if (window.TouchEvent && event instanceof TouchEvent && this._settings.getSetting('input').touch.zoom === 2) {
                x1 = (event.touches[0].pageX - event.touches[1].pageX) / window.innerWidth * (window.innerWidth / window.innerHeight);
                y1 = (event.touches[0].pageY - event.touches[1].pageY) / window.innerHeight;
            }
            this._cameraLogic.zoom(x1, y1, this._active.zoom, window.TouchEvent && event instanceof TouchEvent);
        }
    };
    OrthographicEventDistribution.prototype.onTouchEnd = function (event) {
        this.onUp(event);
    };
    OrthographicEventDistribution.prototype.onTouchMove = function (event) {
        this.onMove(event);
    };
    OrthographicEventDistribution.prototype.onTouchStart = function (event) {
        this.onDown(event);
    };
    OrthographicEventDistribution.prototype.onUp = function (event) {
        this._active.zoom = false;
        this._active.pan = false;
    };
    OrthographicEventDistribution.prototype.onWheel = function (event) {
        if (!this._settings.getSetting('enableZoom'))
            return;
        var delta = 0;
        if (event.deltaY !== undefined) {
            // WebKit / Opera / Explorer 9
            delta = -event.deltaY;
        }
        else if (event.detail !== undefined) {
            // Firefox
            delta = -event.detail;
        }
        if (Math.sign(delta) > 0) {
            this._cameraLogic.zoom(0, 0, false, false);
            this._cameraLogic.zoom(1.0, 0, true, false);
        }
        else {
            this._cameraLogic.zoom(1.0, 0, false, false);
            this._cameraLogic.zoom(0, 0, true, false);
        }
    };
    OrthographicEventDistribution.prototype.reset = function () {
        this._active = {
            zoom: false,
            pan: false
        };
    };
    // #endregion Public Methods (14)
    // #region Private Methods (1)
    OrthographicEventDistribution.prototype.convertInput = function (event) {
        var aspect = window.innerWidth / window.innerHeight;
        if (event instanceof MouseEvent) {
            return {
                x: event.clientX / window.innerWidth * aspect,
                y: event.clientY / window.innerHeight
            };
        }
        else {
            return {
                x: event.touches[0].pageX / window.innerWidth * aspect,
                y: event.touches[0].pageY / window.innerHeight
            };
        }
    };
    return OrthographicEventDistribution;
}());
exports.OrthographicEventDistribution = OrthographicEventDistribution;
